import {useTheme} from "@emotion/react";

import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferListOffer} from "../../../../offer/types/IOfferListOffer";

interface IProps {
    offer: IOfferListOffer;
    vendor: {name: string; slug: string};
    text?: string;
}
export const PricesMarkerPopup = (props: IProps) => {
    const theme = useTheme();
    const href = useOfferLink(props.offer);

    const getPopupContent = () => {
        return (
            <>
                <Text as="div" variant="info_txt_2" strong css={[m(0)]}>
                    {props.offer.name}
                </Text>

                <Text as="div" variant="info_txt_2" color={theme.colors.gray["700"]} css={[m(0, 0, 0.5, 0)]}>
                    {props.vendor.name}
                </Text>

                {props.text ? (
                    <Text as="div" variant="info_txt_2" css={[m(0)]}>
                        {props.text}
                    </Text>
                ) : null}
            </>
        );
    };

    return (
        <div css={[p(2)]}>
            <a href={href} target="_blank">
                {getPopupContent()}
            </a>
        </div>
    );
};
import {useTheme} from "@emotion/react";

import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferListOffer} from "../../../../offer/types/IOfferListOffer";

interface IProps {
    offer: IOfferListOffer;
    vendor: {name: string; slug: string};
    text?: string;
}
export const PricesMarkerPopup = (props: IProps) => {
    const theme = useTheme();
    const href = useOfferLink(props.offer);

    const getPopupContent = () => {
        return (
            <>
                <Text as="div" variant="info_txt_2" strong css={[m(0)]}>
                    {props.offer.name}
                </Text>

                <Text as="div" variant="info_txt_2" color={theme.colors.gray["700"]} css={[m(0, 0, 0.5, 0)]}>
                    {props.vendor.name}
                </Text>

                {props.text ? (
                    <Text as="div" variant="info_txt_2" css={[m(0)]}>
                        {props.text}
                    </Text>
                ) : null}
            </>
        );
    };

    return (
        <div css={[p(2)]}>
            <a href={href} target="_blank">
                {getPopupContent()}
            </a>
        </div>
    );
};
